import { useMutation } from '@apollo/client'
import { DeleteVaccinationRecord, DeleteVaccinationRecordVariables } from '../../types'
import { DELETE_VACCINATION_RECORD } from './operations'

export const useDeleteVaccinationRecord = () =>
  useMutation<DeleteVaccinationRecord, DeleteVaccinationRecordVariables>(DELETE_VACCINATION_RECORD)
